























































import Vue from 'vue';
import * as Util from '@/util.ts';
import * as Enums from '@/enums.ts';

export default Vue.extend({
  data() {
    return {
      isHidden: this.$store.state.currentUserEstablishmentExchangeObject.serverReview && this.$store.state.currentUserEstablishmentExchangeObject.experienceReview,
    };
  },
  computed: {
    serviceReviewEnabled(): boolean {
      return Util.isFeatureEnabled(this.$store.state.featureFlags.serviceReview);
    },
    serverReview(): number {
      return this.$store.state.currentUserEstablishmentExchangeObject.serverReview;
    },
    experienceReview(): number {
      return this.$store.state.currentUserEstablishmentExchangeObject.experienceReview;
    },
    finishedRewiewing(): boolean {
      return Boolean(this.serverReview && this.experienceReview);
    },
  },
  watch: {
    finishedRewiewing(newFinishedRewiewingVal) {
      if (newFinishedRewiewingVal === 4) {
        Util.showNotice(Util.t?.mediumFeedback);
      } else if (newFinishedRewiewingVal <= 3) {
        Util.showNotice(Util.t?.lowFeedback);
      }
    },
  },
  methods: {
    serverRate(rating: number) {
      Util.updateExchangeObject({
        serverReview: rating,
      });
    },
    experienceRate(rating: number) {
      Util.updateExchangeObject({
        experienceReview: rating,
      });
    },
    onGoogleReviewClick() {
      window.open(`http://search.google.com/local/writereview?placeid=ChIJdRwXCgA1K4gRwkdKuHeOulw`);
    },
  },
});
